export default __webpack_public_path__ + "static/media/image.d752097c.less";